import React, { useState } from 'react'

// custom functions
import { useViewport } from 'utils'

// styles
import styles from './index.module.scss'

import 'react-placeholder/lib/reactPlaceholder.css'

import { getDisplayUserName } from 'utils/strings'
import ThreeDotIcon from 'assets/icons/three-dot-icon.svg?component'
import ImageWithFoster from 'components/ImageWithFoster'
import ProfileMenuModal from 'components/Modal/ProfileMenuModal'
import MenuShareProfile from 'components/Menu/MenuShareProfile'

const ProfileArtistCard = props => {
  const { image, name, setFullScreenView, hasLoading, setOpenShareModal, copyWalletAddress } = props
  const viewport = useViewport()
  const [showMenuModal, setshowMenuModal] = useState(false)

  return (
    <div className={styles.container}>
      <div className="w-full flex justify-between items-start">
        <div className={styles.avatarArea}>
          {hasLoading ? (
            <div className={`${styles.skeletonLoader} w-[90px] h-[90px] rounded-[10px]`}></div>
          ) : (
            <ImageWithFoster
              src={image}
              alt=""
              width={90}
              height={90}
              className="w-[90px] h-[90px]"
              onClick={setFullScreenView}
            />
          )}
        </div>

        <div className="hidden items-center lg:flex">
          <MenuShareProfile setOpenShareModal={setOpenShareModal} copyWalletAddress={copyWalletAddress} />
        </div>

        <div
          className="w-[32px] h-[32px] flex items-center justify-end lg:hidden cursor-pointer"
          onClick={() => setshowMenuModal(true)}
        >
          <ThreeDotIcon />
        </div>
      </div>

      {viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? (
        hasLoading ? (
          <div className={`${styles.skeletonLoader} ${styles.name} w-[250px] h-[36px] rounded-full mt-[15px]`}></div>
        ) : (
          <div className={styles.name}>{getDisplayUserName(name)}</div>
        )
      ) : hasLoading ? (
        <div className={`${styles.skeletonLoader} ${styles.name} w-[150px] h-[36px] rounded-full mt-[15px]`}></div>
      ) : (
        <div className={styles.name}>{getDisplayUserName(name)}</div>
      )}

      {showMenuModal && (
        <ProfileMenuModal
          open={showMenuModal}
          onClose={() => setshowMenuModal(false)}
          setOpenShareModal={setOpenShareModal}
          copyWalletAddress={copyWalletAddress}
        />
      )}
    </div>
  )
}

export default ProfileArtistCard
